import type { UploadAvatarModel } from '@/types/avatarModel';
import type { CommonResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';

export function getSasToken(blobName: string) {
  return Request<CommonResponse<any>>({
    url: '/rest/azure/blob/getSasToken',
    method: 'get',
    params: {
      blobName
    }
  }).then((res: any) => {
    if (res.data?.code === 0) {
      return res.data.data;
    }

    throw new Error(res);
  });
}

export function uploadAvatar(glbUrl: string) {
  return Request<CommonResponse<UploadAvatarModel>>({
    url: '/rest/os/mind/profile/avatar/upload/3d',
    method: 'post',
    data: {
      url: glbUrl
    }
  });
}

export function getUploadToken(blobName: string): Promise<string> {
  return Request({
    url: '/rest/azure/blob/getSasToken',
    method: 'get',
    params: {
      blobName
    }
  }).then((res: any) => {
    if (res.data?.code === 0) {
      return res.data.data;
    }

    throw new Error(res);
  });
}

export function getTencentUploadToken(blobName: string, globalBucket?: boolean): Promise<string> {
  return Request({
    url: '/rest/tencent/blob/getSasToken',
    method: 'get',
    params: {
      blobName,
      globalBucket
    }
  }).then((res: any) => {
    if (res.data?.code === 0) {
      return res.data.data;
    }

    throw new Error(res);
  });
}

export function getTencentUploadTokenPost(data: {
  blobName: string;
  globalBucket?: boolean;
}): Promise<string> {
  return Request({
    url: '/rest/tencent/blob/getSasTokenPost',
    method: 'post',
    data
  }).then((res: any) => {
    if (res.data?.code === 0) {
      return res.data.data;
    }

    throw new Error(res);
  });
}

export function getCloudFlareUploadUrl(data: {
  blobName: string;
}): Promise<{ url: string; domain: string }> {
  return Request({
    url: '/rest/os/cdn/getUploadUrl',
    method: 'post',
    data
  }).then((res: any) => {
    if (res.data?.code === 0) {
      return res.data.data;
    }

    throw new Error(res);
  });
}

export function getCloudFlareUploadUrlWithoutToken(data: {
  blobName: string;
}): Promise<{ url: string; domain: string }> {
  return Request({
    url: '/rest/os/cdn/getUploadUrl/bd',
    method: 'post',
    data
  }).then((res: any) => {
    if (res.data?.code === 0) {
      return res.data.data;
    }

    throw new Error(res);
  });
}
